import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useApi from "../../../CustomHooks/useApi";
import { Wallet, Loader2 } from "lucide-react";
import imps from './settlement_images/imps.jpeg'
import upi from './settlement_images/upi.JPG'

import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const AepsSettlement2 = () => {
  const navigate = useNavigate();

  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [showRegister, setShowRegister] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [mobileLocked, setMobileLocked] = useState(false);

  // APIs
  const { callApi: checkStatus } = useApi("/payout/status", "GET");
  const { callApi: sendOtpApi } = useApi("/payout/send-otp", "POST");
  const { callApi: verifyOtpApi } = useApi("/payout/verify-otp", "POST");

  /* ================= CHECK CUSTOMER STATUS ================= */
  const handleCheckMobile = async () => {
    if (!/^[6-9]\d{9}$/.test(mobile)) {
      setMessage("Enter valid 10 digit mobile");
      setMessageType("error");
      return;
    }

    setIsLoading(true);
    setMessage("");

    try {
      const res = await checkStatus(null, `?mobile=${mobile}`);

      if (res?.isVerified) {
        navigate("/aepsremitter2", {
          state: { mobile, name },
        });
      } else {
        setShowRegister(true);
        setMobileLocked(true);
      }
    } catch (err) {
      console.error(err);
      setMessage("Server error");
      setMessageType("error");
    }

    setIsLoading(false);
  };

  /* ================= SEND OTP (NO REGISTER API) ================= */
  const handleSendOtp = async () => {
    if (!name || !address) {
      setMessage("Enter name and address");
      setMessageType("error");
      return;
    }

    setIsLoading(true);
    setMessage("");

    try {
      const res = await sendOtpApi({ mobile });

      if (res?.status === "OTP_SENT") {
        setShowOtp(true);
        setMessage(res.message || "OTP sent successfully");
        setMessageType("success");
      } else {
        setMessage("OTP send failed");
        setMessageType("error");
      }
    } catch (err) {
      console.error(err);
      setMessage("OTP send failed");
      setMessageType("error");
    }

    setIsLoading(false);
  };

  /* ================= VERIFY OTP (WITH NAME + ADDRESS) ================= */
  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      setMessage("Enter valid 6 digit OTP");
      setMessageType("error");
      return;
    }

    setIsLoading(true);
    setMessage("");

    try {
      const res = await verifyOtpApi({
        mobile,
        otp,
        name,
        address,
      });

      if (res?.status === "VERIFIED" && res?.isVerified) {
        setMessage("Customer verified successfully");
        setMessageType("success");

        setTimeout(() => {
          navigate("/aepsremitter2", {
            state: { mobile, name },
          });
        }, 1000);
      } else {
        setMessage("Invalid OTP");
        setMessageType("error");
      }
    } catch (err) {
      console.error(err);
      setMessage("OTP verify failed");
      setMessageType("error");
    }

    setIsLoading(false);
  };

  return (
    //      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-10 px-4 
    //                 flex flex-col lg:flex-row gap-8">

    //   {/* LEFT PANEL */}
    //   <div className="flex-1">
    //     <div className="bg-white w-full h-auto border border-slate-200 rounded-2xl shadow-md 
    //                     p-6 sm:p-8 flex flex-col gap-8">

    //       {/* Heading */}
    //       <div className="flex items-start gap-5">
    //         <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-600 to-cyan-500 
    //                         flex items-center justify-center text-white shadow-lg">
    //           <CreditCard className="w-8 h-8" />
    //         </div>

    //         <div>
    //           <h2 className="text-2xl font-semibold text-slate-800">
    //             AEPS Settlement (UPI)
    //           </h2>
    //           <p className="text-gray-500 text-sm mt-1">
    //             Verify customer and proceed with secure UPI Transfers
    //           </p>
    //         </div>
    //       </div>

    //       {/* FORM AREA */}
    //       <div className="max-w-full space-y-5">

    //         <label className="text-sm font-medium text-slate-700">Mobile Number</label>

    //         {/* Input + Button Row */}
    //         <div className="flex flex-col sm:flex-row gap-4">

    //           {/* Input */}
    //           <input
    //             type="text"
    //             name="phone"
    //             inputMode="numeric"
    //             value={mobile}
    //             maxLength={10}
    //             disabled={mobileLocked}
    //             onKeyDown={(e) => e.key === 'Enter' && handleCheckMobile()}
    //             onChange={(e) => /^\d*$/.test(e.target.value) && setMobile(e.target.value)}
    //             className="flex-1 px-4 py-3 rounded-xl border border-slate-300 
    //                        focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 
    //                        disabled:bg-gray-100 transition"
    //             placeholder="Enter 10-digit mobile number"
    //           />

    //           {/* Check Button */}
    //           {!showRegister && !showOtp && (
    //             <button
    //               onClick={handleCheckMobile}
    //               className="sm:w-40 w-full px-4 py-3 bg-[#12345A] hover:bg-[#0F2E47]
    //                          text-white rounded-xl font-semibold shadow-md transition"
    //             >
    //               {isLoading ? "Checking..." : "Check"}
    //             </button>
    //           )}

    //         </div>

    //         {/* Registration Fields */}
    //         {showRegister && (
    //           <div className="space-y-3">
    //             <input
    //               value={name}
    //               onChange={(e) => setName(e.target.value)}
    //               placeholder="Customer Name"
    //               className="w-full px-4 py-3 border rounded-xl"
    //             />

    //             <textarea
    //               value={address}
    //               onChange={(e) => setAddress(e.target.value)}
    //               placeholder="Address"
    //               className="w-full px-4 py-3 border rounded-xl"
    //             />

    //             <button
    //               onClick={handleSendOtp}
    //               className="w-full px-4 py-3 bg-[#12345A] hover:bg-[#0F2E47]
    //                          text-white rounded-xl font-semibold shadow-md transition"
    //             >
    //               {isLoading ? "Sending OTP..." : "Send OTP"}
    //             </button>
    //           </div>
    //         )}

    //         {/* OTP Section */}
    //         {showOtp && (
    //           <div className="space-y-3">
    //             <label className="text-sm font-medium">Enter OTP</label>

    //             <input
    //               value={otp}
    //               maxLength={6}
    //               onChange={(e) => /^\d*$/.test(e.target.value) && setOtp(e.target.value)}
    //               className="w-full px-4 py-3 border rounded-xl"
    //             />

    //             <button
    //               onClick={handleVerifyOtp}
    //               className="w-full py-3 bg-green-600 text-white rounded-xl font-semibold 
    //                          flex items-center justify-center gap-2"
    //             >
    //               {isLoading && <Loader2 className="animate-spin w-5 h-5" />}
    //               Verify OTP
    //             </button>
    //           </div>
    //         )}

    //         {/* Message Alert */}
    //         {message && (
    //           <div
    //             className={`px-4 py-3 rounded-xl text-sm ${
    //               messageType === "success"
    //                 ? "bg-green-100 text-green-700"
    //                 : "bg-red-100 text-red-700"
    //             }`}
    //           >
    //             {message}
    //           </div>
    //         )}

    //       </div>
    //     </div>
    //   </div>

    //   {/* RIGHT PANEL (Carousel) */}
    // <div className="w-full lg:w-[28%]">
    //     <div className="bg-white border border-slate-200 rounded-2xl shadow-md p-2">
    //       <Carousel showArrows={true} showThumbs={false} showStatus={false} infiniteLoop autoPlay={true}
    // interval={3000}
    // stopOnHover={false}
    // swipeable={true}>

    //         <div>
    //           <img
    //             className="rounded-xl"
    //             src={imps}
    //           />
    //         </div>


    //         <div>
    //           <img className="rounded-xl"   src={upi}/>
    //         </div>
    //       </Carousel>
    //     </div>
    //   </div>


    // </div>

    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-6 sm:py-10 px-4 
                flex flex-col lg:flex-row gap-6 lg:gap-8">

      {/* LEFT PANEL */}
      <div className="flex-1">
        <div className="bg-white w-full h-auto border border-slate-200 rounded-2xl shadow-md 
                    p-5 sm:p-8 flex flex-col gap-6">

          {/* Heading */}
          <div className="flex items-start gap-4 sm:gap-5">
            <div className="w-12 h-12 sm:w-14 sm:h-14 shrink-0 rounded-2xl bg-[#F6F6F6] 
                        flex items-center justify-center text-[#12345A] shadow-md">
              <Wallet className="w-6 h-6 sm:w-8 sm:h-8" />
            </div>

            <div>
              <h2 className="text-xl sm:text-2xl font-semibold text-slate-800">
                AEPS Settlement (UPI)
              </h2>
              <p className="text-gray-500 text-xs sm:text-sm mt-1">
                Verify customer and proceed with secure UPI Transfers
              </p>
            </div>
          </div>

          {/* FORM AREA */}
          <div className="w-full space-y-4 sm:space-y-5">

            <label className="text-lg sm:text-xl font-medium text-slate-700 block">
              Mobile Number
            </label>

            {/* Input Row */}
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="text"
                name="phone"
                inputMode="numeric"
                value={mobile}
                maxLength={10}
                disabled={mobileLocked}
                onKeyDown={(e) => e.key === 'Enter' && handleCheckMobile()}
                onChange={(e) => /^\d*$/.test(e.target.value) && setMobile(e.target.value)}
                className="w-full min-h-[60px] sm:min-h-[70px] px-4 py-3 rounded-xl border border-[#12345A] 
                       focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
                       disabled:bg-gray-100 transition text-xl sm:text-[22px] text-red-600 font-bold bg-[#F6F6F6] shadow-sm
                       [&:-webkit-autofill]:[-webkit-text-fill-color:#dc2626] 
                       [&:-webkit-autofill]:[-webkit-box-shadow:0_0_0_1000px_#F6F6F6_inset] 
                       [&:-webkit-autofill]:transition-none"
                placeholder="Enter 10-digit mobile number"
              />
            </div>

            {/* Check Button */}
            {!showRegister && !showOtp && (
              <button
                onClick={handleCheckMobile}
                className="w-full px-4 py-3 sm:py-4 bg-[#12345A] hover:bg-[#0F2E47] 
                       text-white rounded-xl font-semibold shadow-md transition"
              >
                {isLoading ? "Checking..." : "Check"}
              </button>
            )}

            {/* Registration Fields */}
            {/* {showRegister && (
          <div className="space-y-3 sm:space-y-4">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Customer Name"
              className="w-full min-h-[50px] sm:min-h-[60px] px-4 py-3 rounded-xl border border-[#12345A] 
                         focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
                         disabled:bg-gray-100 transition text-lg sm:text-xl bg-[#F6F6F6] shadow-sm
                         [&:-webkit-autofill]:[-webkit-text-fill-color:#334155] 
                         [&:-webkit-autofill]:[-webkit-box-shadow:0_0_0_1000px_#F6F6F6_inset]"
            />

            <input
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Address"
              className="w-full min-h-[50px] sm:min-h-[60px] px-4 py-3 rounded-xl border border-[#12345A] 
                         focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
                         disabled:bg-gray-100 transition text-lg sm:text-xl bg-[#F6F6F6] shadow-sm
                         [&:-webkit-autofill]:[-webkit-text-fill-color:#334155] 
                         [&:-webkit-autofill]:[-webkit-box-shadow:0_0_0_1000px_#F6F6F6_inset]"
            />

            <button
              onClick={handleSendOtp}
              className="w-full px-4 py-3 sm:py-4 bg-[#12345A] hover:bg-[#0F2E47] 
                         text-white rounded-xl font-semibold shadow-md transition"
            >
              {isLoading ? "Sending OTP..." : "Send OTP"}
            </button>
          </div>
        )} */}

            {showRegister && (
              <div className="space-y-3">
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSendOtp()} // Trigger OTP
                  placeholder="Customer Name"
                  className="w-full h-14 sm:h-16 px-4 py-3 rounded-xl border border-[#12345A] focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 disabled:bg-gray-100 transition text-[22px] font-semibold bg-[#F6F6F6] shadow-lg"
                />

                <input
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSendOtp()} // Trigger OTP
                  placeholder="Address"
                  className="w-full h-14 sm:h-16 px-4 py-3 rounded-xl border border-[#12345A] focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 disabled:bg-gray-100 transition text-[22px] font-semibold bg-[#F6F6F6] shadow-lg"
                />

                <button onClick={handleSendOtp} className="
     w-full px-4 py-3 bg-[#12345A] hover:bg-[#0F2E47] text-white  rounded-xl font-semibold shadow-md transition
  ">
                  {isLoading ? "Sending OTP..." : "Send OTP"}
                </button>
              </div>
            )}

            {/* OTP Section */}
            {/* {showOtp && (
          <div className="space-y-3">
            <label className="text-sm font-medium text-slate-700">Enter OTP</label>

            <input
              value={otp}
              maxLength={6}
              onChange={(e) => /^\d*$/.test(e.target.value) && setOtp(e.target.value)}
              className="w-full min-h-[50px] sm:min-h-[60px] px-4 py-3 rounded-xl border border-[#12345A] 
                         focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 
                         transition text-lg sm:text-xl bg-[#F6F6F6] shadow-sm"
            />

            <button
              onClick={handleVerifyOtp}
              className="w-full py-3 sm:py-4 bg-green-600 hover:bg-green-700 text-white rounded-xl font-semibold 
                         flex items-center justify-center gap-2 shadow-md transition"
            >
              {isLoading && <Loader2 className="animate-spin w-5 h-5" />}
              Verify OTP
            </button>
          </div>
        )} */}

            {showOtp && (
              <div className="space-y-3">
                <label className="text-sm font-medium">Enter OTP</label>
                <input
                  value={otp}
                  maxLength={6}
                  onChange={(e) => /^\d*$/.test(e.target.value) && setOtp(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleVerifyOtp()} // Trigger Verify
                  className="w-full h-14 sm:h-16 px-4 py-3 rounded-xl border border-[#12345A] focus:ring-2 focus:ring-indigo-100 focus:border-indigo-100 disabled:bg-gray-100 transition text-[22px] font-semibold bg-[#F6F6F6] shadow-lg"
                />

                <button onClick={handleVerifyOtp} className="w-full py-3 bg-green-600 text-white rounded-xl font-semibold flex items-center justify-center gap-2">
                  Verify OTP
                </button>
              </div>
            )}


            {/* Message Alert */}
            {message && (
              <div
                className={`px-4 py-3 rounded-xl text-sm font-medium ${messageType === "success"
                    ? "bg-green-100 text-green-800"
                    : "bg-red-100 text-red-800"
                  }`}
              >
                {message}
              </div>
            )}

          </div>
        </div>
      </div>

      {/* RIGHT PANEL (Carousel) */}
      {/* <div className="w-full lg:w-[28%] mt-4 lg:mt-0">
        <div className="bg-white border border-slate-200 rounded-2xl shadow-md p-2">
          <Carousel
            showArrows={true}
            showThumbs={false}
            showStatus={false}
            infiniteLoop
            autoPlay={true}
            interval={3000}
            stopOnHover={false}
            swipeable={true}
          >
            <div>
              <img className="rounded-xl object-cover" src={imps} alt="IMPS" />
            </div>
            <div>
              <img className="rounded-xl object-cover" src={upi} alt="UPI" />
            </div>
          </Carousel>
        </div>
      </div> */}

    </div>
  );
};

export default AepsSettlement2;
